import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { Heading } from "components/Heading";
import ResetsAndContent from "../tabs/ResetsAndContent";
import useMcapFilters from "../useMcapFilters";
import typography from "../typography";

export default function ResetsAndContentScreen() {
  const { filters, renderFilterBar } = useMcapFilters();

  return (
    <div className="page-content">
      <Helmet>
        <title>{typography.TAB_RESETS_CONTENT} · MCAP</title>
      </Helmet>
      <Container fluid className="mcap-hub">
        <Heading heading={typography.TAB_RESETS_CONTENT} />
        <ResetsAndContent filters={filters} filterBar={renderFilterBar("content")} />
      </Container>
    </div>
  );
}
